<template>
  <v-sheet>
    <headline-bar>
      <template v-slot:prepend-btn>
        <v-btn icon @click.stop="dismissSideSheet">
          <v-icon>{{
            sideSheetIsOn && $vuetify.breakpoint.xs ? icons.back : icons.close
          }}</v-icon>
        </v-btn>
      </template>

      Location info
    </headline-bar>

    <v-form ref="form" v-model="valid" lazy-validation class="pa-6 flex-grow-1">
      <!-- Country / Currency -->
      <!-- <v-autocomplete
        v-model="user.countryCurrency"
        :items="regionsArray"
        return-object
        item-text="name"
        item-value="code"
        label="Country / Currency"
        placeholder="Select ..."
        no-data-text="Country / Currency is not available"
        required
        filled
        color="secondary"
      >
        <template v-slot:item="data">
          <v-list-item-avatar size="32">
            <v-icon class="flag-border" size="24">${{ data.item.flag }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title> {{ data.item.name }} </v-list-item-title>
          </v-list-item-content>
        </template>
      </v-autocomplete> -->

      <v-text-field
        label="Country / Currency"
        placeholder=""
        filled
        color="secondary"
        :value="locationInfo.countryCurrency.value"
        disabled
      ></v-text-field>

      <!-- City/Province and Postal code -->
      <v-text-field
        v-model="user.cityProvince"
        label="City / Province"
        placeholder=""
        filled
        color="secondary"
      ></v-text-field>
      <v-text-field
        v-model="user.postalCode"
        :rules="postalRules"
        label="Postal code"
        placeholder=""
        filled
        color="secondary"
      ></v-text-field>

      <!-- Timezone -->
      <v-autocomplete
        v-model="user.timeZone"
        :items="timezone"
        return-object
        item-text="name"
        item-value="code"
        @contextmenu.native="disableContextMenu"
        label="Timezone"
        placeholder="Select ..."
        no-data-text="Timezone is not available"
        required
        filled
        color="secondary"
      >
        <template v-slot:item="data">
          <!-- <v-list-item-avatar size="32">
            <v-icon class="flag-border" size="24"> ${{ data.item.flag }} </v-icon>
          </v-list-item-avatar> -->
          <v-list-item-content>
            <v-list-item-title> {{ data.item.name + ' (GMT ' + data.item.gmt + ')'}} </v-list-item-title>
          </v-list-item-content>
        </template>
      </v-autocomplete>

      <!-- Primary address -->
      <v-textarea
        v-model="user.address1"
        filled
        auto-grow
        rows="1"
        color="secondary"
        clear-icon="mdi-close-circle"
        name="textareaGrow"
        label="Primary address"
      ></v-textarea>

      <!-- Secondary address -->
      <v-textarea
        v-model="user.address2"
        filled
        auto-grow
        rows="1"
        color="secondary"
        clear-icon="mdi-close-circle"
        name="textareaGrow"
        label="Secondary address"
      ></v-textarea>

      <v-btn
        :light="$vuetify.theme.dark"
        :dark="!$vuetify.theme.dark"
        class="float-right"
        @click="locationChange"
      >
        Submit
      </v-btn>
    </v-form>
  </v-sheet>
</template>

<script>
export default {
  data() {
    return {
      user: {
        // countryCurrency: "",
        cityProvince: "",
        postalCode: "",
        timeZone: "",
        address1: "",
        address2: "",
      },

      valid: true,
      postalRules: [v => v.length <= 10 || 'Max 10 characters'],
    };
  },
  computed: {
    sideSheetIsOn() {
      return this.$store.getters["SideSheet/isOn"];
    },
    timezone() {
      return this.$store.getters["Countries/countries"];
    },
    locationInfo() {
      return this.$store.getters["Profile/locationInfo"];
    },
  },

  methods: {
    dismissSideSheet() {
      this.$store.dispatch("SideSheet/toggleSideSheet", { isOn: false });
    },

    locationChange() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("Profile/locationChange", { user: this.user });
        this.dismissSideSheet();
      }
    },
  },
  created() {},
  mounted() {
    this.sideSheet = this.sideSheetIsOn;
    this.user.cityProvince = this.locationInfo.cityProvince.value;
    this.user.postalCode = this.locationInfo.postalCode.value;
    this.user.address1 = this.locationInfo.address1.value;
    this.user.address2 = this.locationInfo.address2.value;
    this.user.timeZone = this.locationInfo.timeZone.info;
  },
};
</script>

<style lang="sass" scoped>
.flag-border
  border: 1px solid rgba(#111111, 0.1)
  border-style: outset
</style>
